import { render, staticRenderFns } from "./CadastroRequisicao.vue?vue&type=template&id=6012a420&scoped=true&"
import script from "./CadastroRequisicao.vue?vue&type=script&lang=js&"
export * from "./CadastroRequisicao.vue?vue&type=script&lang=js&"
import style0 from "./CadastroRequisicao.vue?vue&type=style&index=0&id=6012a420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012a420",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VIcon,VStepper,VStepperContent,VStepperStep})
